import { render, staticRenderFns } from "./shoulder.vue?vue&type=template&id=472ba792&scoped=true&"
import script from "./shoulder.vue?vue&type=script&lang=js&"
export * from "./shoulder.vue?vue&type=script&lang=js&"
import style0 from "./shoulder.vue?vue&type=style&index=0&id=472ba792&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "472ba792",
  null
  
)

export default component.exports